import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../../../form/DirtyFormPrompt";
import { useMemo, useState } from "react";

import { NewSelectedValuesForLicenseChangeLevel } from "../../../drawer/ChangeMachineLicensesDrawer";
import dayjs from "dayjs";
import { formatUTCDate } from "../../../../../helper/dateHelper";
import { useChangeMachineLicenses } from "../../../../../hooks/machineLicenses/useChangeMachineLicenses";
import { DisplayChangeMachineLicensesChanges } from "./DisplayChangeMachineLicensesChanges";

type ChangeMachineLicensesChangesProps = {
  callbackFn: (
    obj: NewSelectedValuesForLicenseChangeLevel,
    license:
      | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
      | undefined
  ) => void;
  stepback: () => void;
  currentLicense:
  | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
  | undefined;
  newValuesToChangeLevel?: NewSelectedValuesForLicenseChangeLevel,
};

export type InitialValueType = {
  subscription_code?: string;
  subscription_start_date: Date | null;
  new_sub_start_date: Date | null;
  reduce_license_count: number;
  new_subscription_code: string;
}

export const ChangeMachineLicensesChanges: React.FC<
  ChangeMachineLicensesChangesProps
> = ({ newValuesToChangeLevel, currentLicense, stepback, callbackFn }) => {
  const queryClient = useQueryClient();
  const queryKey = "changelevel-querylicensemanage";
  // if (currentLicense && currentLicense.renews_on) {
  //   currentLicense.renews_on = undefined
  //   currentLicense.subscription_start_date = dayjs("2025-10-27").toDate()
  // }
  //const { t } = useTranslation();

  const changelevelLicenseAndSendEmail = useChangeMachineLicenses();

  // const initialValues: InitialValueType = {
  //   subscription_code: "",
  //   subscription_start_date: currentLicense?.renews_on
  //     ? dayjs(formatUTCDate(currentLicense?.renews_on)).startOf("day").toDate()
  //     : currentLicense?.subscription_start_date ? dayjs(formatUTCDate(currentLicense?.subscription_start_date)).startOf("day").toDate()
  //       : null,
  //   new_sub_start_date: currentLicense?.renews_on
  //     ? dayjs(formatUTCDate(currentLicense?.renews_on)).startOf("day").toDate()
  //     : currentLicense?.subscription_start_date ? dayjs(formatUTCDate(currentLicense?.subscription_start_date)).startOf("day").toDate()
  //       : null,
  //   reduce_license_count: 0
  // }
  const initialValues: any = useMemo(() => {
    if (newValuesToChangeLevel) {
      return {
        new_sub_start_date: newValuesToChangeLevel?.new_sub_start_date ?? null,
        new_subscription_code: newValuesToChangeLevel?.new_subscription_code ?? "",
        reduce_license_count: newValuesToChangeLevel?.reduce_license_count ?? 0
      }
    } else {
      return {
        subscription_code: "",
        subscription_start_date: currentLicense?.renews_on
          ? dayjs(formatUTCDate(currentLicense?.renews_on)).startOf("day").toDate()
          : currentLicense?.subscription_start_date ? dayjs(formatUTCDate(currentLicense?.subscription_start_date)).startOf("day").toDate()
            : null,
        new_sub_start_date: currentLicense?.renews_on
          ? dayjs(formatUTCDate(currentLicense?.renews_on)).startOf("day").toDate()
          : currentLicense?.subscription_start_date ? dayjs(formatUTCDate(currentLicense?.subscription_start_date)).startOf("day").toDate()
            : null,
        reduce_license_count: 0,
        new_subscription_code: ""
      }
    }
  }, [newValuesToChangeLevel, currentLicense])
  console.log("initialValue ", JSON.stringify(initialValues))
  const [displayValues, setDisplayValues] = useState({
    // new_version_id_display_value: "",
    new_subscription_code_display_value: "",
  });

  const callBackForSubscriptionCodeDisplayValue = (v: any) => {
    setDisplayValues({
      ...displayValues,
      new_subscription_code_display_value: v,
    });
  };

  const handleChangeMachineLicenses = async (
    values: any,
    formikHelpers: FormikHelpers<any>,
    options: {}
  ) => {
    console.log("JSON IS ", JSON.stringify(values))

    //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity:
      | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
      | undefined = await changelevelLicenseAndSendEmail({
        step: 2,
        email_address: currentLicense?.email_address ?? "",
        transaction_id: currentLicense?.transaction_id ?? "",
        language: currentLicense?.language ?? "",
        new_sub_start_date: values?.new_sub_start_date ?? undefined,
        new_subscription_code: values?.new_subscription_code ?? "",
        reduce_license_count: values?.reduce_license_count,
        subscription_code: currentLicense?.subscription_code
      });

    debugger;
    callbackFn(
      {
        new_sub_start_date: values?.new_sub_start_date ?? null,
        new_subscription_code: values?.new_subscription_code ?? "",
        new_subscription_code_display_value:
          displayValues.new_subscription_code_display_value,
        subscription_start_date: values?.subscription_start_date ?? null,
        reduce_license_count: values?.reduce_license_count
      },
      newEntity
    );
  };
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    await onChangeMachineLicenses(values, formikHelpers, {});
  };

  const formSubmitToChangeMachineLicenses = () => {
    return [
      async (values: any, formikHelpers: FormikHelpers<any>) => {
        return handleChangeMachineLicenses(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.ChangeLevel",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licenses.basic.detail", "changelevel"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onChangeMachineLicenses = useFormSubmit(
    ...formSubmitToChangeMachineLicenses()
  );

  return (
    <FullWidthSpace direction="vertical" size="large">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <div>
          <DirtyFormPrompt>
            <DisplayChangeMachineLicensesChanges
              currentLicense={currentLicense}
              stepback={stepback}
              callBackForSubscriptionCodeDisplayValue={
                callBackForSubscriptionCodeDisplayValue
              }
            />
          </DirtyFormPrompt>
        </div>
      </Formik>
    </FullWidthSpace>
  );
};
